(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window
        .matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`,
      );
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate',
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["k12"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.k12__field-slider').forEach(function (slider) {
    var track = slider.querySelector('.k12__photo-ribbon');
    var slides = slider.querySelectorAll('.k12__photo-ribbon-slide');
    var dotsContainer = slider.querySelector('.k12__field-dots');
    var prevButton = slider.querySelector('.k12__field-button--prev');
    var nextButton = slider.querySelector('.k12__field-button--next');

    if (!track || !slides.length || !dotsContainer) return;

    var dots = [];

    function updateArrowState() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (prevButton) prevButton.disabled = track.scrollLeft <= 1;
      if (nextButton) nextButton.disabled = maxScroll <= 0 || track.scrollLeft >= maxScroll - 1;
    }

    function getStep() {
      var gap =
        parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
      return slides[0].getBoundingClientRect().width + gap;
    }

    function buildDots() {
      var step = getStep();
      if (!step) return;

      var perPage = Math.max(1, Math.round(track.clientWidth / step));
      var dotCount = Math.max(1, slides.length - perPage + 1);

      if (dotCount === dots.length) {
        updateActiveDot();
        return;
      }

      dotsContainer.innerHTML = '';
      dots = [];

      for (var i = 0; i < dotCount; i += 1) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.setAttribute('aria-label', 'Go to photo ' + (i + 1));
        (function (slideIndex) {
          dot.addEventListener('click', function () {
            var target = slides[slideIndex];
            if (target) track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
          });
        })(i);
        dotsContainer.appendChild(dot);
        dots.push(dot);
      }

      updateActiveDot();
    }

    function updateActiveDot() {
      if (!dots.length) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      var currentIndex;
      if (maxScroll <= 0 || track.scrollLeft >= maxScroll - 1) {
        currentIndex = dots.length - 1;
      } else {
        var step = getStep();
        currentIndex = step ? Math.min(dots.length - 1, Math.round(track.scrollLeft / step)) : 0;
      }
      dots.forEach(function (dot, index) {
        if (index === currentIndex) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });
      updateArrowState();
    }

    track.addEventListener('scroll', updateActiveDot);
    new ResizeObserver(buildDots).observe(track);
    buildDots();

    if (slider.dataset.autoplay !== 'true') return;

    function advance() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 1) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollTo({ left: track.scrollLeft + getStep(), behavior: 'smooth' });
      }
    }

    var autoplayId = setInterval(advance, 4000);
    function pauseAutoplay() {
      clearInterval(autoplayId);
    }
    function resumeAutoplay() {
      clearInterval(autoplayId);
      autoplayId = setInterval(advance, 4000);
    }
    slider.addEventListener('mouseenter', pauseAutoplay);
    slider.addEventListener('mouseleave', resumeAutoplay);
    slider.addEventListener('focusin', pauseAutoplay);
    slider.addEventListener('focusout', function (event) {
      if (!slider.contains(event.relatedTarget)) resumeAutoplay();
    });
  });

  document.querySelectorAll('.k12__field-lightbox').forEach(function (lightbox) {
    var track = lightbox.querySelector('.k12__field-lightbox-track');
    var slides = lightbox.querySelectorAll('.k12__field-lightbox-slide');
    var prevButton = lightbox.querySelector('.k12__field-lightbox-button--prev');
    var nextButton = lightbox.querySelector('.k12__field-lightbox-button--next');

    if (!track || !slides.length) return;

    var currentIndex = 0;

    function goTo(index) {
      currentIndex = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + currentIndex * 100 + '%)';
    }

    [prevButton, nextButton].forEach(function (button) {
      if (!button) return;
      button.addEventListener('pointerup', function (event) {
        event.stopPropagation();
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', function () {
        goTo(currentIndex - 1);
      });
    }
    if (nextButton) {
      nextButton.addEventListener('click', function () {
        goTo(currentIndex + 1);
      });
    }

    lightbox.addEventListener('keyup', function (event) {
      if (event.code === 'ArrowLeft') goTo(currentIndex - 1);
      if (event.code === 'ArrowRight') goTo(currentIndex + 1);
    });

    lightbox.openToIndex = goTo;
  });

  document.querySelectorAll('.k12__photo-ribbon-trigger[data-lightbox-index]').forEach(function (trigger) {
    trigger.addEventListener('click', function () {
      var opener = trigger.closest('modal-opener');
      if (!opener) return;
      var modal = document.querySelector(opener.getAttribute('data-modal'));
      if (modal && typeof modal.openToIndex === 'function') {
        modal.openToIndex(parseInt(trigger.dataset.lightboxIndex, 10) || 0);
      }
    });
  });

  (function () {
    var counters = document.querySelectorAll('.k12__impact-count');
    if (!counters.length) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var duration = 1500;

    function parseCount(raw) {
      var match = raw.match(/^(\D*)([\d,]*\.?\d+)(\D*)$/);
      if (!match) return null;
      var decimals = match[2].indexOf('.') > -1 ? match[2].split('.')[1].length : 0;
      return {
        prefix: match[1],
        suffix: match[3],
        value: parseFloat(match[2].replace(/,/g, '')),
        decimals: decimals,
      };
    }

    function animateCount(el, parsed) {
      var start = performance.now();

      function tick(now) {
        var progress = Math.min(1, (now - start) / duration);
        var eased = 1 - Math.pow(1 - progress, 3);
        var current = parsed.value * eased;
        el.textContent =
          parsed.prefix +
          current.toLocaleString(undefined, {
            minimumFractionDigits: parsed.decimals,
            maximumFractionDigits: parsed.decimals,
          }) +
          parsed.suffix;

        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          el.textContent = parsed.prefix + parsed.value.toLocaleString() + parsed.suffix;
        }
      }

      requestAnimationFrame(tick);
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          observer.unobserve(el);

          var parsed = parseCount(el.dataset.countTo || el.textContent);
          if (!parsed) return;

          if (prefersReducedMotion) {
            el.textContent = parsed.prefix + parsed.value.toLocaleString() + parsed.suffix;
            return;
          }

          el.textContent = parsed.prefix + (0).toLocaleString() + parsed.suffix;
          animateCount(el, parsed);
        });
      },
      { threshold: 0.5 },
    );

    counters.forEach(function (el) {
      observer.observe(el);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-coleccio-de-productos-2"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const grid = document.querySelector('#productos-grid-{{ section.id }}');

    if (grid) {
      // You can apply horizontal scroll, swiper, or other specific logic here
      console.log('Colección cargada para sección {{ section.id }}');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-coleccion-de-prodcutos-relacionados"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const grid = document.querySelector('#productos-grid-{{ section.id }}');

    if (grid) {
      // You can apply horizontal scroll, swiper, or other specific logic here
      console.log('Colección cargada para sección {{ section.id }}');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-coleccion-de-productos-filtros"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    console.log('Script cargado correctamente');

    // Select all filters
    const filtroItems = document.querySelectorAll('.filtro-item');
    if (filtroItems.length === 0) {
      console.error('No se encontraron elementos .filtro-item');
      return;
    }

    // Attach click event to each filter
    filtroItems.forEach((item) => {
      item.addEventListener('click', function () {
        const button = this.querySelector('.filtro-tipo-boton');
        if (!button) {
          console.error('No se encontró el botón dentro del filtro:', this);
          return;
        }

        const sectionId = button.dataset.section;
        const tipo = button.dataset.tipo;

        console.log(`Filtro activado: sección=${sectionId}, tipo=${tipo}`);

        // Call the product filtering function
        filterProducts(sectionId, tipo);
      });
    });

    // Function to filter products
    function filterProducts(sectionId, tipo) {
      console.log(`Filtrando productos: sección=${sectionId}, tipo=${tipo}`);

      // Deactivate all buttons
      const buttons = document.querySelectorAll(`.filtro-tipo-${sectionId} .filtro-tipo-boton`);
      buttons.forEach((btn) => {
        btn.classList.remove('active');
        btn.style.backgroundColor = 'transparent';
        btn.style.border = `2px solid {{ section.settings.color_boton_1 }}`;

        // Clear child (div) styles
        const childDiv = btn.querySelector('div');
        if (childDiv) {
          childDiv.style.backgroundImage = 'none';
        }
      });

      // Activate the corresponding button
      const activeButton = document.querySelector(
        `.filtro-tipo-${sectionId} .filtro-tipo-boton[data-tipo="${tipo}"]`,
      );
      if (activeButton) {
        activeButton.classList.add('active');
        activeButton.style.backgroundColor =
          tipo === 'todos' ? '{{ section.settings.color_boton_1 }}' : 'transparent';
        activeButton.style.border = `2px solid {{ section.settings.color_boton_1 }}`;

        // Update child (div) styles of the active button
        const childDiv = activeButton.querySelector('div');
        if (childDiv) {
          if (tipo === 'todos') {
            childDiv.style.backgroundImage =
              'url({{ section.settings.filtro_todos_imagen_activa | image_url }} )';
          } else {
            const index = activeButton.closest('.filtro-item').classList[1].split('-')[2]; // Extract the filter index
            childDiv.style.backgroundImage = `url({{ section.settings['filtro_manual_' + index + '_imagen_activa'] | image_url }})`;
          }
          childDiv.style.backgroundPosition = 'center';
          childDiv.style.backgroundSize = 'contain';
          childDiv.style.backgroundRepeat = 'no-repeat';
        }
      } else {
        console.error('No se encontró el botón activo para el tipo:', tipo);
      }

      // Filter products
      const productCards = document.querySelectorAll(
        `.card-item-coleccion[data-section="${sectionId}"]`,
      );
      productCards.forEach((card) => {
        const cardType = card.dataset.tipo;
        if (tipo === 'todos') {
          card.style.display = 'block';
        } else {
          card.style.display = cardType === tipo ? 'block' : 'none';
        }
      });
    }

    // Force showing all products on load
    setTimeout(() => {
      const defaultSectionId = '{{ section_id }}';
      filterProducts(defaultSectionId, 'todos');
    }, 100);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-portada-unicolumna-slider"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  const slider = document.querySelector('.swiper-container');

  if (slider) {
    const loop = slider.getAttribute('data-autorotate') === 'true';
    const delay = parseInt(slider.getAttribute('data-speed'), 10);

    const swiper = new Swiper('.swiper-container', {
      loop: loop,
      autoplay: loop ? { delay: delay } : false,
      pagination: {
        el: '.swiper-pagination',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev'
      }
    });
  }
});

  } catch(e) { console.error(e); }
})();
})();
